<div
  class="p-fare-rule-detail-panel__body-item"
  [ngClass]="{ 'p-fare-rule-detail-panel__body-item--not-first-child': ptcIndex > 0 }"
  tabindex="0"
>
  <div class="p-fare-rule-detail-panel__title">
    <!-- 搭乗者種別(PTC) -->
    <div class="p-fare-rule-detail-panel__title-label p-fare-rule-detail-panel__title-label--em">
      <ng-container [ngSwitch]="data.ptc">
        <span *ngSwitchCase="'ADT'" [innerHTML]="'label.adult' | staticMsg"></span>
        <span *ngSwitchCase="'B15'" [innerHTML]="'label.youngAdult' | staticMsg"></span>
        <span *ngSwitchCase="'CHD'" [innerHTML]="'label.child' | staticMsg"></span>
        <span *ngSwitchCase="'INF'" [innerHTML]="'label.infant' | staticMsg"></span>
        <span *ngSwitchCase="'INS'" [innerHTML]="'label.ins' | staticMsg"></span>
      </ng-container>
    </div>
    <!-- per person -->
    <div class="p-fare-rule-detail-panel__title-lead" [innerHTML]="'label.passenger2' | staticMsg"></div>
  </div>
  <dl class="c-def-list02">
    <div class="c-def-list02__item" tabindex="0">
      <dt class="c-def-list02__item-title" aria-hidden="true" [innerHTML]="'label.fareName' | staticMsg"></dt>
      <dd class="c-def-list02__item-body">
        <dl class="c-float-list01">
          <div class="c-float-list01__item">
            <dt class="c-float-list01__title" [innerHTML]="'label.fareName' | staticMsg"></dt>
            <dd class="c-float-list01__contents c-float-list01__contents--fs16">
              <!-- FF名称 -->
              <div
                class="c-float-list01__contents-item c-float-list01__contents-item--em c-float-list01__contents-item--chd-align-r"
              >
                <span class="c-float-list01__contents-item-chd--align-l">
                  {{ data.fareFamilyName }}
                </span>
              </div>
              <!-- FareBasis -->
              <div
                class="c-float-list01__contents-item c-float-list01__contents-item--normal c-float-list01__contents-item--chd-align-r"
              >
                <span *ngIf="data.fareBasis" class="c-float-list01__contents-item-chd--align-l">
                  {{ data.fareBasis }}
                </span>
                <span
                  *ngIf="!data.fareBasis"
                  class="c-float-list01__contents-item-chd--align-l"
                  [innerHTML]="'label.hyphen' | staticMsg"
                ></span>
              </div>
              <!-- R01P040 プラン確認画面：国内DCS移行後日付の国内単独旅程以外の運賃詳細リンク -->
              <div
                *ngIf="data.fareDetailLink"
                class="c-float-list01__contents-item c-float-list01__contents-item--normal c-float-list01__contents-item--chd-align-r"
              >
                <a
                  id="fare-condition-details-fare-detail-link-{{ boundIndex }}-{{ ptcIndex }}"
                  class="c-float-list01__contents-item-chd--align-l"
                  [href]="data.fareDetailLink | metaUrl"
                  target="_blank"
                >
                  <span [innerHTML]="'label.more' | staticMsg"></span>
                  <img
                    class="c-text-link-external c-text-link-external--large"
                    src="assets/images/icon_external_primary_20.svg"
                    width="20"
                    height="20"
                    [attr.alt]="'alt.openLinkInNewTab' | staticMsg"
                  />
                </a>
              </div>
              <!-- R01P080 支払情報入力/R01P083 ANA Biz支払情報入力：国内DCS移行後日付の国内単独旅程以外の運賃詳細リンク -->
              <div
                *ngIf="!data.fareDetailLink && !data.isDomesticAfterDcs"
                [innerHTML]="'label.fare.details' | staticMsg"
                class="c-float-list01__contents-item c-float-list01__contents-item--normal c-float-list01__contents-item--chd-align-r"
              >
                <img
                  class="c-text-link-external c-text-link-external--large"
                  src="assets/images/icon_external_primary_20.svg"
                  width="20"
                  height="20"
                  [attr.alt]="'alt.openLinkInNewTab' | staticMsg"
                />
              </div>
              <!-- 共通：国内DCS移行後日付の国内単独旅程の運賃詳細リンク -->
              <div
                *ngIf="data.isDomesticAfterDcs"
                [innerHTML]="'label.domestic.fareDetails.link' | staticMsg"
                class="c-float-list01__contents-item c-float-list01__contents-item--normal c-float-list01__contents-item--chd-align-r"
              >
                <img
                  class="c-text-link-external c-text-link-external--large"
                  src="assets/images/icon_external_primary_20.svg"
                  width="20"
                  height="20"
                  [attr.alt]="'alt.openLinkInNewTab' | staticMsg"
                />
              </div>
            </dd>
          </div>
        </dl>
      </dd>
    </div>
    <div class="c-def-list02__item" tabindex="0">
      <!-- 変更ルール -->
      <dt class="c-def-list02__item-title" [innerHTML]="'label.changeItinerary' | staticMsg"></dt>
      <dd class="c-def-list02__item-body">
        <dl class="c-float-list01">
          <div class="c-float-list01__item">
            <!-- 出発前 -->
            <dt class="c-float-list01__title" [innerHTML]="'label.beforeDep' | staticMsg"></dt>
            <dd
              class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal c-float-list01__contents--long-text"
            >
              <span
                *ngIf="data.changeConditions.beforeDeparture"
                [innerHTML]="data.changeConditions.beforeDeparture"
              ></span>
              <span *ngIf="!data.changeConditions.beforeDeparture" [innerHTML]="'label.hyphen' | staticMsg"></span>
            </dd>
          </div>
          <div class="c-float-list01__item">
            <!-- 出発前 No Show -->
            <dt class="c-float-list01__title" [innerHTML]="'label.beforeDepNoShow' | staticMsg"></dt>
            <dd
              class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal c-float-list01__contents--long-text"
            >
              <span
                *ngIf="data.changeConditions.beforeDepartureNoShow"
                [innerHTML]="data.changeConditions.beforeDepartureNoShow"
              >
              </span>
              <span
                *ngIf="!data.changeConditions.beforeDepartureNoShow"
                [innerHTML]="'label.hyphen' | staticMsg"
              ></span>
            </dd>
          </div>
          <div class="c-float-list01__item">
            <!-- 出発後 -->
            <dt class="c-float-list01__title" [innerHTML]="'label.afterDep' | staticMsg"></dt>
            <dd
              class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal c-float-list01__contents--long-text"
            >
              <span
                *ngIf="data.changeConditions.afterDeparture"
                [innerHTML]="data.changeConditions.afterDeparture"
              ></span>
              <span *ngIf="!data.changeConditions.afterDeparture" [innerHTML]="'label.hyphen' | staticMsg"></span>
            </dd>
          </div>
          <div class="c-float-list01__item">
            <!-- 出発後 No Show -->
            <dt class="c-float-list01__title" [innerHTML]="'label.afterDepNoShow' | staticMsg"></dt>
            <dd
              class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal c-float-list01__contents--long-text"
            >
              <span
                *ngIf="data.changeConditions.afterDepartureNoShow"
                [innerHTML]="data.changeConditions.afterDepartureNoShow"
              >
              </span>
              <span *ngIf="!data.changeConditions.afterDepartureNoShow" [innerHTML]="'label.hyphen' | staticMsg"></span>
            </dd>
          </div>
        </dl>
      </dd>
    </div>
    <div class="c-def-list02__item" tabindex="0">
      <!-- 払戻ルール -->
      <dt class="c-def-list02__item-title" [innerHTML]="'label.refund' | staticMsg"></dt>
      <dd class="c-def-list02__item-body">
        <dl class="c-float-list01">
          <div class="c-float-list01__item">
            <!-- 出発前 -->
            <dt class="c-float-list01__title" [innerHTML]="'label.beforeDep' | staticMsg"></dt>
            <dd
              class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal c-float-list01__contents--long-text"
            >
              <span
                *ngIf="data.refundConditions.beforeDeparture"
                [innerHTML]="data.refundConditions.beforeDeparture"
              ></span>
              <span *ngIf="!data.refundConditions.beforeDeparture" [innerHTML]="'label.hyphen' | staticMsg"></span>
            </dd>
          </div>
          <div class="c-float-list01__item">
            <!-- 出発前 No Show -->
            <dt class="c-float-list01__title" [innerHTML]="'label.beforeDepNoShow' | staticMsg"></dt>
            <dd
              class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal c-float-list01__contents--long-text"
            >
              <span
                *ngIf="data.refundConditions.beforeDepartureNoShow"
                [innerHTML]="data.refundConditions.beforeDepartureNoShow"
              >
              </span>
              <span
                *ngIf="!data.refundConditions.beforeDepartureNoShow"
                [innerHTML]="'label.hyphen' | staticMsg"
              ></span>
            </dd>
          </div>
          <div class="c-float-list01__item">
            <!-- 出発後 -->
            <dt class="c-float-list01__title" [innerHTML]="'label.afterDep' | staticMsg"></dt>
            <dd
              class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal c-float-list01__contents--long-text"
            >
              <span
                *ngIf="data.refundConditions.afterDeparture"
                [innerHTML]="data.refundConditions.afterDeparture"
              ></span>
              <span *ngIf="!data.refundConditions.afterDeparture" [innerHTML]="'label.hyphen' | staticMsg"></span>
            </dd>
          </div>
          <div class="c-float-list01__item">
            <!-- 出発後 No Show -->
            <dt class="c-float-list01__title" [innerHTML]="'label.afterDepNoShow' | staticMsg"></dt>
            <dd
              class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal c-float-list01__contents--long-text"
            >
              <span
                *ngIf="data.refundConditions.afterDepartureNoShow"
                [innerHTML]="data.refundConditions.afterDepartureNoShow"
              >
              </span>
              <span *ngIf="!data.refundConditions.afterDepartureNoShow" [innerHTML]="'label.hyphen' | staticMsg"></span>
            </dd>
          </div>
        </dl>
      </dd>
    </div>
  </dl>
</div>
